import type {ButtonProps} from '@yandex-delivery/blocks'
import {Button, UnstableCard as Paper} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React, {memo} from 'react'

import * as classes from './FixedButton.classes'

type FixedButtonProps = Omit<ButtonProps, 'm' | 'mb' | 'ml' | 'mr' | 'mt' | 'mx' | 'my' | 'variant'>

export const FixedButton = memo(
  ({children, ...props}: FixedButtonProps): React.ReactElement => (
    <Paper className={clsx(classes.fixedButtonWrapper)} padding="S">
      <Button {...props} variant="action">
        {children}
      </Button>
    </Paper>
  ),
)
